"use strict";

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var stream_1 = require("stream");
/**
 * Transforms a stream of SPARQL JSON bindings object to parsed bindings.
 */


var SparqlJsonBindingsTransformer =
/*#__PURE__*/
function (_stream_1$Transform) {
  _inherits(SparqlJsonBindingsTransformer, _stream_1$Transform);

  function SparqlJsonBindingsTransformer(parser) {
    var _this;

    _classCallCheck(this, SparqlJsonBindingsTransformer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SparqlJsonBindingsTransformer).call(this, {
      objectMode: true
    }));
    _this.parser = parser;
    return _this;
  }

  _createClass(SparqlJsonBindingsTransformer, [{
    key: "_transform",
    value: function _transform(chunk, encoding, callback) {
      callback(null, this.parser.parseJsonBindings(chunk));
    }
  }]);

  return SparqlJsonBindingsTransformer;
}(stream_1.Transform);

exports.SparqlJsonBindingsTransformer = SparqlJsonBindingsTransformer;